import jwtDecode from 'jwt-decode';

import { ROLE_ACCOMMODATION_PROVIDER, ROLE_GUEST, ROLE_UNAUTHENTICATED_GUEST } from '@spa/shared/constants/roleTypes';

export const USER_KEY = 'UNI_USER';
export const REGISTRATION_PLATFORM_SELF_SERVICE = 'self-service';
export const AUTHENTICATION_HEADER = 'authentication_token';
export const EMBER_AUTHENTICATION_KEY = 'ember_simple_auth-session';

export const loadProfile = storage => JSON.parse(storage.getItem(USER_KEY)) || null;

export const saveProfile = (storage, profile) => storage.setItem(USER_KEY, JSON.stringify(profile));

export const clearProfile = storage => storage.removeItem(USER_KEY);

export const clearEmberStorage = storage => storage.removeItem(EMBER_AUTHENTICATION_KEY);

const addSignupParam = (url, isSignUp) => {
  if (!isSignUp) {
    return url;
  }

  const urlObj = new URL(url === '/' ? window.location.origin : url);
  if (urlObj.pathname === '/signup') {
    return `${url.href}?signedUp=true`;
  }

  urlObj.searchParams.set('signedUp', 'true');

  return urlObj.toString();
};

export const handleRedirect = (redirectFn, token, isSignup = false) => {
  const from = document.referrer;
  const queryParams = new URLSearchParams(window.location.search);
  const isAP = isAccommodationProvider(token);

  if (queryParams.has('from') && queryParams.get('from') === REGISTRATION_PLATFORM_SELF_SERVICE) {
    redirectFn(
      addSignupParam(isSignup || !isAP ? queryParams.get('redirect_url') : `${process.env.AP_URL}listings`, isSignup)
    );

    return;
  }

  if (queryParams.has('redirect_url')) {
    const redirectUrl = queryParams.get('redirect_url');
    const isStudentDashboardRedirect = redirectUrl.includes('dashboard');

    redirectFn(addSignupParam(isAP && isStudentDashboardRedirect ? process.env.AP_URL : redirectUrl, isSignup));

    return;
  }

  if (isAP) {
    setTimeout(() => {
      redirectFn(addSignupParam(isSignup ? process.env.SELF_SERVICE_URL : process.env.AP_URL, isSignup));
    }, 2000);

    return;
  }

  if (from && from.includes(process.env.COOKIE_DOMAIN) && window.location.origin !== from) {
    redirectFn(addSignupParam(from, isSignup));

    return;
  }

  redirectFn(addSignupParam('/', isSignup));
};

export const getIdFromCookie = cookies => {
  try {
    const auth = jwtDecode(cookies[AUTHENTICATION_HEADER]);
    const { roles, user_roles: ids } = auth;

    return roles.indexOf(ROLE_GUEST) < 0 ? null : ids[ROLE_GUEST];
  } catch {
    return null;
  }
};

export const cleanAuth = (storage, localStorage, removeCookie) => {
  removeCookie(AUTHENTICATION_HEADER, {
    domain: process.env.COOKIE_DOMAIN
  });

  clearProfile(storage);
  clearEmberStorage(localStorage);
};

export const getAccountId = token => {
  try {
    const { account_id } = jwtDecode(token);

    return account_id;
  } catch {
    return null;
  }
};

export const getRole = token =>
  getRoles(token).includes(ROLE_ACCOMMODATION_PROVIDER) ? ROLE_ACCOMMODATION_PROVIDER : ROLE_GUEST;

export const getRoles = token => {
  if (!token) {
    return [];
  }

  try {
    const { roles } = jwtDecode(token);

    return roles;
  } catch {
    return [];
  }
};

export const isGuestUnauthenticated = token => getRoles(token).includes(ROLE_UNAUTHENTICATED_GUEST);

export const isAccommodationProvider = token => getRole(token) === ROLE_ACCOMMODATION_PROVIDER;

export const getIdFromToken = token => {
  try {
    const auth = jwtDecode(token);
    const { roles, user_roles: ids } = auth;

    return roles.indexOf(ROLE_GUEST) < 0 ? null : ids[ROLE_GUEST];
  } catch {
    return null;
  }
};

export const getUsernameFromToken = token => {
  try {
    const { username } = jwtDecode(token);

    return username;
  } catch {
    return null;
  }
};
